import axios from 'axios';

import * as actionTypes from './actionTypes';

import getEmailResponse from '../../assets/json/getEmail.json';
import normalEmailLoginResponse from '../../assets/json/normalEmailLogin.json';

let prod = false;

export const updateLoginStatus = (status) => {
    return {
        type: actionTypes.UPDATE_LOGIN_STATUS,
        val: status
    }
}

export const startAuthentication = () => {
    return {
        type: actionTypes.START_AUTHENTICATION
    }
}

export const stopAuthentication = () => {
    return {
        type: actionTypes.STOP_AUTHENTICATION
    }
}

export const setAuthFlow = (val) => {
    return {
        type: actionTypes.SET_AUTH_FLOW,
        flow: val
    }
}

export const setAuthView = (val) => {
    return {
        type: actionTypes.SET_AUTH_VIEW,
        view: val
    }
}

// Email

export const getEmailStatus = (status, email, flow) => {
    return {
        type: actionTypes.GET_EMAIL_STATUS,
        val: status,
        email: email,
        flow: flow
    }
}

// Loading OTP

export const setOTPLoading = () => {
    return {
        type: actionTypes.SET_OTP_LOADING
    }
}

// Set OTP

export const setOTP = (data, ssoToken) => {
    return {
        type: actionTypes.SET_OTP,
        code: data.code,
        interactionIds: data.interactionIds,
        ssoToken: ssoToken
    }
}

export const getOTPFailed = () => {
    return {
        type: actionTypes.GET_OTP_FAILED
    }
}

// Get OTP

export const getOTP = (ssoToken) => {
    return dispatch => {
        setOTPLoading();
        let OTPData = {
            "ssoToken": ssoToken,
            "verificationModes": ["Mobile", "Email"]
        };

        let url='http://localhost:3000/auth/getVerificationModeLoggedInOTP';
        if(prod) {
            url='https://secure.yatra.com/quicksilvercontroller/auth/getVerificationModeLoggedInOTP';
        }
        axios.post(url, OTPData)
            .then(response => {
                const responseHttpCode = response.data.httpCode;
                if (responseHttpCode === '200') {
                    dispatch(setOTP(response.data, ssoToken));
                } else {
                    dispatch(getOTPFailed());    
                }
            })
            .catch(error => {
                dispatch(getOTPFailed());
            })
    }
}

// Set Resend OTP

export const setResendOTP = () => {
    return {
        type: actionTypes.SET_RESEND_OTP
    }
}

export const getResendOTPFailed = () => {
    return {
        type: actionTypes.GET_RESEND_OTP_FAILED
    }
}

// Get Resend OTP

export const getResendOTP = (interactionIds) => {
    return dispatch => {
        dispatch(setOTPLoading());
        let resendOTPData = {
            "interactionIds": interactionIds
        };
        let url ='http://localhost:3000/auth/resendVerificationModeLoggedInOTP';
        if(prod) {
            url='https://secure.yatra.com/quicksilvercontroller/auth/resendVerificationModeLoggedInOTP';
        }
        axios.post(url, resendOTPData)
            .then(response => {
                const responseHttpCode = response.data.httpCode;
                if (responseHttpCode === '200') {
                    dispatch(setResendOTP(response));
                } else {
                    dispatch(getResendOTPFailed());    
                }
            })
            .catch(error => {
                dispatch(getResendOTPFailed(error));
            })
    }
}

// Set Verify OTP

export const setVerifyOTP = (data) => {
    return {
        type: actionTypes.SET_VERIFY_OTP
    }
}

export const getVerifyOTPFailed = () => {
    return {
        type: actionTypes.GET_VERIFY_OTP_FAILED
    }
}

// Get Verify OTP

export const getVerifyOTP = (mode, otp, interactionId, ssoToken) => {
    return dispatch => {
        dispatch(setOTPLoading());
        let verifyOTPData = null;
        if (mode === 'Email') {
            verifyOTPData = {
                "interactionInfo": {
                    "Email": {
                        "interactionId": interactionId,
                        "otp": otp
                    }
                }
            }
        } else {
            verifyOTPData = {
                "interactionInfo": {
                    "Mobile": {
                        "interactionId": interactionId,
                        "otp": otp
                    }
                }
            }
        }
        let url = 'http://localhost:3000/auth/verifyVerificationModeLoggedInOTP';
        if(prod) {
            url='https://secure.yatra.com/quicksilvercontroller/auth/verifyVerificationModeLoggedInOTP';
        }
        axios.post(url, verifyOTPData)
            .then(response => {
                const responseHttpCode = response.data.httpCode;
                const ssoCode = response.data.code;
                if (responseHttpCode === '200' && (ssoCode === 'SSO-200-VTSLS-005' || ssoCode === 'SSO-200-VTSLS-002')) {
                    localStorage.setItem("ssoToken", ssoToken);
                    dispatch(setVerifyOTP());
                } else {
                    dispatch(getVerifyOTPFailed());
                }
            })
            .catch(error => {
                dispatch(getVerifyOTPFailed(error));
            })
    }
}

// Normal Login Start

export const normalLoginStart = () => {
    return {
        type: actionTypes.NORMAL_LOGIN_START
    }
}

// Normal Login Success

export const normalLoginSuccess = (ssoToken) => {
    return {
        type: actionTypes.NORMAL_LOGIN_SUCCESS,
        ssoToken: ssoToken
    }
}

// Normal Login Failure

export const normalLoginFail = () => {
    return {
        type: actionTypes.NORMAL_LOGIN_FAIL
    }
}

// Normal login

export const normalLogin = (email, password) => {
  return dispatch => {
        // dispatch(normalLoginStart());
        let normalLoginData = {};
        // let url='http://localhost:3000/auth/normalB2BEmailLogin';
        // if(prod) {
        //     url='https://secure.yatra.com/quicksilvercontroller/auth/normalB2BEmailLogin';
        // }
        normalLoginData = {
            emailId: email,
            password: password
        }
        const responseHttpCode = normalEmailLoginResponse.httpCode;
                const ssoToken = normalEmailLoginResponse.ssoToken;
                if (responseHttpCode === '200') {
                    let innerUrl = 'http://localhost:3000/auth/getB2BLoginInfo';
                    if (prod) {
                        innerUrl = 'https://secure.yatra.com/quicksilvercontroller/auth/getB2BLoginInfo';
                    }
                    axios.post(innerUrl, {ssoToken: ssoToken})
                        .then(response => {
                            const innerResponseHttpCode = normalEmailLoginResponse.httpCode;
                            if (innerResponseHttpCode === '200') {
                                if (normalEmailLoginResponse.twoStepAuthenticationEnabled === false) {
                                    localStorage.setItem("ssoToken", ssoToken);
                                    dispatch(normalLoginSuccess(ssoToken));
                                } else {
                                    dispatch(getOTP(normalEmailLoginResponse.ssoToken));
                                }
                            } else if (responseHttpCode === '400' || '401' || '404' || '500') {
                                dispatch(normalLoginFail());
                            }
                        })
                } else if (responseHttpCode === '400' || '401' || '404' || '500') {
                    dispatch(normalLoginFail());
                }
        // axios.post(url, normalLoginData)
        // .then(response => {
        //         const responseHttpCode = response.data.httpCode;
        //         const ssoToken = response.data.ssoToken;
        //         if (responseHttpCode === '200') {
        //             let innerUrl = 'http://localhost:3000/auth/getB2BLoginInfo';
        //             if (prod) {
        //                 innerUrl = 'https://secure.yatra.com/quicksilvercontroller/auth/getB2BLoginInfo';
        //             }
        //             axios.post(innerUrl, {ssoToken: ssoToken})
        //                 .then(response => {
        //                     const innerResponseHttpCode = response.data.httpCode;
        //                     if (innerResponseHttpCode === '200') {
        //                         if (response.data.twoStepAuthenticationEnabled === false) {
        //                             localStorage.setItem("ssoToken", ssoToken);
        //                             dispatch(normalLoginSuccess(ssoToken));
        //                         } else {
        //                             dispatch(getOTP(response.data.ssoToken));
        //                         }
        //                     } else if (responseHttpCode === '400' || '401' || '404' || '500') {
        //                         dispatch(normalLoginFail());
        //                     }
        //                 })
        //         } else if (responseHttpCode === '400' || '401' || '404' || '500') {
        //             dispatch(normalLoginFail());
        //         }
        // })
        // .catch(error => {
        //         dispatch(normalLoginFail());
        // });
    }
}

// Validity Loading

export const authValidityLoading = () => {
    return {
        type: actionTypes.AUTH_VALIDITY_LOADING
    }
}

export const authValidityCheckFailed = () => {
    return {
        type: actionTypes.AUTH_VALIDITY_CHECK_FAILED
    }
}

// Email & Mobile Validity Check

export const authValidityCheck = (userInput) => {
    return dispatch => {
        const responseHttpCode = getEmailResponse.httpCode;
        if (responseHttpCode === '200') {
            if (getEmailResponse.status) {
                dispatch(getEmailStatus('EMAIL_AVAILABLE', userInput));
            } else if (!getEmailResponse.status) {
                dispatch(getEmailStatus('EMAIL_UNAVAILABLE', userInput));
            }
        } else if (responseHttpCode === '400') {
            dispatch(authValidityCheckFailed());
        }
        // dispatch(authValidityLoading());
        // let url = 'http://localhost:3000/auth/getB2BEmailAvalability?emailId=';
        // if(prod) {
        //     url = 'https://secure.yatra.com/quicksilvercontroller/auth/getB2BEmailAvalability?emailId=';
        // }
        // axios.get(url + userInput)
        //     .then(response => {
        //         const responseHttpCode = response.data.httpCode;
        //         if (responseHttpCode === '200') {
        //             if (response.data.status) {
        //                 dispatch(getEmailStatus('EMAIL_AVAILABLE', userInput));
        //             } else if (!response.data.status) {
        //                 dispatch(getEmailStatus('EMAIL_UNAVAILABLE', userInput));
        //             }
        //         } else if (responseHttpCode === '400') {
        //             dispatch(authValidityCheckFailed());
        //         }
        //     })
        //     .catch(error => {
        //         dispatch(authValidityCheckFailed());
        //     });
    }
}

// Logout Start

export const logoutStart = () => {
    return {
        type: actionTypes.LOGOUT_START
    }
}

// Logout Success

export const logoutSuccess = () => {
    return {
        type: actionTypes.LOGOUT_SUCCESS
    }
}

// Logout Fail

export const logoutFail = () => {
    return {
        type: actionTypes.LOGOUT_FAIL
    }
}

// Logout 

export const authLogout = (ssoToken) => {
    return dispatch => {
        dispatch(logoutStart());
        const logoutData = {
            ssoToken: ssoToken
        }
        let url = 'http://localhost:3000/auth/logout';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/auth/logout';
        }
        axios.post(url, logoutData)
            .then(response => {
                const responseHttpCode = response.data.httpCode;
                if (responseHttpCode === '200') {
                    localStorage.clear();
                    dispatch(logoutSuccess());
                } else if (responseHttpCode === '400' || '401' || '404' || '500') {
                    dispatch(logoutFail());
                }
            })
            .catch(error => {
                dispatch(logoutFail());
            })
    }
}

// Password Recovery 

export const passwordRecoveryStart = () => {
    return {
        type: actionTypes.PASSWORD_RECOVERY_START
    }
}

export const passwordMailFail = () => {
    return {
        type: actionTypes.PASSWORD_MAIL_FAIL
    }
}

export const passwordMailSent = () => {
    return {
        type: actionTypes.PASSWORD_MAIL_SENT
    }
}

export const forgotPassword = (email) => {
    return dispatch => {
        dispatch(passwordRecoveryStart());
        let url = 'http://localhost:3000/auth/forgotB2BPassword?emailId=';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/auth/forgotB2BPassword?emailId=';
        }
        axios.get(url + email)
            .then(response => {
                const responseHttpCode = response.data.httpCode;
                if (responseHttpCode === '200') {
                    dispatch(passwordMailSent());
                } else {
                    dispatch(passwordMailFail());
                }
            })
            .catch(error => {
                dispatch(passwordMailFail());
            });
    }
}

export const passwordRecoveryCompleted = () => {
    return {
        type: actionTypes.PASSWORD_RECOVERY_COMPLETED
    }
}

export const passwordRecoveryFailed = () => {
    return {
        type: actionTypes.PASSWORD_RECOVERY_FAILED
    }
}

export const resetPassword = (newPassword, recoveryToken) => {
    return dispatch => {
        dispatch(passwordRecoveryStart());
        const resetPasswordData = {
            recoveryToken: recoveryToken,
            newPassword: newPassword
        }
        let url = 'http://localhost:3000/auth/resetPassword';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/auth/resetPassword';
        }
        axios.post(url, resetPasswordData)
            .then(response => {
                const responseHttpCode = response.data.httpCode;
                if (responseHttpCode === '200') {
                    dispatch(passwordRecoveryCompleted());
                } else {
                    dispatch(passwordRecoveryFailed());
                }
            })
            .catch(error => {
                dispatch(passwordRecoveryFailed());
            })
    }
}

// UPDATE USER PROFILE

export const updateUserProfile = (ssoToken, userId, gender, firstName, lastName, offers) => {
    const updateUserProfileData = {
        ssoToken: ssoToken,
        userProfileWO: {
            userId: userId,
            personName: {
                honorific: gender,
                firstName: firstName,
                middleName: null,
                lastName: lastName
            },
            offers: offers
        }
    }

    let url = 'http://localhost:3000/user/updateUserProfile';
    if(prod) {
        url = 'https://secure.yatra.com/quicksilvercontroller/user/updateUserProfile';
    }
    axios.put(url, updateUserProfileData)
        .then(response => {
            console.log(response);
        })
        .catch(error => {
            console.log(error);
        })
}

// Update Mobile Number

export const updateMobileNumber = (interactionId, otp, ssoToken) => {
    const updateMobileData = {
        interactionId: interactionId,
        otp: otp,
        ssoToken: ssoToken
    };
    let url = 'http://localhost:3000/user/updateMobileNumber';
    if(prod) {
        url = 'https://secure.yatra.com/quicksilvercontroller/user/updateMobileNumber';
    }
    axios.put(url, updateMobileData)
        .then(response => {
            console.log(response);
        })
        .catch(error => {
            console.log(error);
        });
}

// Update Password

export const updatePassword = (ssoToken, oldPassword, newPassword) => {
    const updatePasswordData = {
        ssoToken: ssoToken,
        oldPassword: oldPassword,
        newPassword: newPassword
    };
    let url = 'http://localhost:3000/user/updatePassword';
    if(prod) {
        url = 'https://secure.yatra.com/quicksilvercontroller/user/updatePassword';
    }
    axios.put(url, updatePasswordData)
        .then(response => {
            console.log(response);
        })
        .catch(error => {
            console.log(error);
        });
}

// User Profile

export const setUserProfileLoading = () => {
    return {
        type: actionTypes.SET_USER_PROFILE_LOADING
    }
}

export const setUserProfile = (userProfile) => {
    return {
        type: actionTypes.SET_USER_PROFILE,
        userProfile: userProfile
    }
}

export const getUserProfileFailed = () => {
    return {
        type: actionTypes.GET_USER_PROFILE_FAILED
    }
}

// GET USER PROFILE

export const getUserProfile = (ssoToken) => {
    return dispatch => {
        dispatch(setUserProfileLoading());
        const userProfileData = {
            "req_method": "post",
            "application": "web",
            "channel": "b2b",
            "method": "getUserProfileDetail",
            "ssoToken": ssoToken
        }
        let url = 'http://localhost:3000/business/getUserProfile';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/business/getUserProfile';
        }
        axios.post(url, userProfileData)
            .then(response => {
                dispatch(setUserProfile(response.data));    
            })
            .catch(error => {
                dispatch(getUserProfileFailed());
            })
    }
}

// Product Access

export const setProductAccess = (productAccess) => {
    return {
        type: actionTypes.SET_PRODUCT_ACCESS,
        val: productAccess
    }
}

export const getProductAccessFailed = () => {
    return {
        type: actionTypes.GET_PRODUCT_ACCESS_FAILED
    }
}

export const getProductAccess = (ssoToken) => {
    return dispatch => {
        const productAccessData = {
            "req_method": "post",
            "application": "web",
            "channel": "b2b",
            "method": "getUserProductAccess",
            "ssoToken": ssoToken
        }
        let url = 'http://localhost:3000/business/getUserProfile';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/business/getProductAccess';
        }
        axios.post(url, productAccessData)
            .then(response => { 
                dispatch(setProductAccess(response.data));
            })
            .catch(error => {
                dispatch(getProductAccessFailed());
            })
    }
}

// Header Menu

export const setHeaderMenu = (headerMenu) => {
    return {
        type: actionTypes.SET_HEADER_MENU,
        val: headerMenu
    }   
}

export const getHeaderMenuFailed = () => {
    return {
        type: actionTypes.GET_HEADER_MENU_FAILED,
    }
}

export const getHeaderMenu = (ssoToken) => {
    return dispatch => {
        const headerMenuData = {
            "application":"web",
            "channel":"b2b",
            "ssoToken": ssoToken,
            "req_method":"post",
            "method":"getHeaderMenu"
        }
        let url = 'http://localhost:3000/business/getHeaderMenu';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/business/getHeaderMenu';
        }
        axios.post(url, headerMenuData)
            .then(response => {
                dispatch(setHeaderMenu(response.data));
            })
            .catch(error => {
                dispatch(getHeaderMenuFailed());
            })
    }
}

// Markup

export const setMarkup = (markup) => {
    return {
        type: actionTypes.SET_MARKUP,
        val: markup
    }
}

export const getMarkupFailed = () => {
    return {
        type: actionTypes.GET_MARUKUP_FAILED
    }
}

export const getMarkup = (ssoToken) => {
    return dispatch => {
        const markupData = {
            "application":"web",
            "channel":"b2b",
            "ssoToken":ssoToken,
            "mtype":"DSM,DTM",
            "req_method":"post",
            "method":"mkup",
            "cache":true
        }
        let url = 'http://localhost:3000/business/getMarkup';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/business/getMarkup';
        }
        axios.post(url, markupData)
            .then(response => {
                dispatch(setMarkup(response.data));
            })
            .catch(error => {
                dispatch(getMarkupFailed());
            })
    }
}

// Check Balance

export const setBalance = (balance) => {
    return {
        type: actionTypes.SET_BALANCE,
        val: balance
    }
}

export const getBalanceFailed = () => {
    return {
        type: actionTypes.GET_BALANCE_FAILED
    }
}

export const getBalance = (ssoToken) => {
    return dispatch => {
        const balanceData = {
            "req_method":"post",
            "application":"web",
            "channel":"b2b",
            "method":"checkBalance",
            "ssoToken": ssoToken
        }
        let url = 'http://localhost:3000/business/getBalance';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/business/getBalance';
        }
        axios.post(url, balanceData)
            .then(response => {  
                dispatch(setBalance(response.data));
            })
            .catch(error => {
                dispatch(getBalanceFailed());
            })
    }
}

// Blocked Amount

export const setBlockedAmount = (blockedAmount) => {
    return {
        type: actionTypes.SET_BLOCKED_AMOUNT,
        val: blockedAmount
    }
}

export const getBlockedAmountFailed = () => {
    return {
        type: actionTypes.GET_BLOCKED_AMOUNT_FAILED
    }
}

export const getBlockedAmount = (ssoToken, superPnr, paymentType, amount) => {
    return dispatch => {
        const blockedAmountData = {
            "superPnr": superPnr,
            "productType": "b2bdom",
            "application": "web",
            "channel": "b2b",
            "paymentType": paymentType,
            "ssoToken": ssoToken,
            "amount": amount,
            "req_method": "post",
            "method": "blockedAmount"
        }
        let url = 'http://localhost:3000/business/getBlockedAmount';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/business/getBlockedAmount';
        }
        axios.post(url, blockedAmountData)
            .then(response => {
                dispatch(setPaymentOptions(response.data))
            })
            .catch(error => {
                dispatch(getBalanceFailed());
            })
    }
}

// Payment Options

export const startPaymentOptionsLoading = () => {
    return {
        type: actionTypes.START_PAYMENT_OPTIONS_LOADING
    }
}

export const stopPaymentOptionsLoading = () => {
    return {
        type: actionTypes.STOP_PAYMENT_OPTIONS_LOADING
    }
}

export const setPaymentOptions = (paymentOptions) => {
    return {
        type: actionTypes.SET_PAYMENT_OPTIONS,
        val: paymentOptions
    }
}

export const getPaymentOptionsFailed = () => {
    return {
        type: actionTypes.GET_PAYMENT_OPTIONS_FAILED
    }
}

export const getPaymentOptions = (ssoToken) => {
    return dispatch => {
        dispatch(startPaymentOptionsLoading());
        const paymentOptionsData = {
            "productType":"b2bdom",
            "application":"web",
            "channel":"b2b",
            "ssoToken":ssoToken,
            "req_method":"post",
            "method":"getPaymentOptions"
        }
        let url = 'http://localhost:3000/business/getPaymentOptions';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/business/getPaymentOptions';
        }
        axios.post(url, paymentOptionsData)
            .then(response => {
                dispatch(setPaymentOptions(response.data))
                // dispatch(stopPaymentOptionsLoading());
            })
            .catch(error => {
                dispatch(getPaymentOptionsFailed());
                // dispatch(stopPaymentOptionsLoading());
            })
    }
}

// Banners

export const setBanners = () => {
    return {
        type: actionTypes.SET_BANNERS
    }
}

export const getBannersFailed = () => {
    return {
        type: actionTypes.GET_BANNERS_FAILED
    }
}

export const getBanners = (ssoToken) => {
    return dispatch => {
        const bannersData = {
            "application":"web",
            "channel":"b2b",
            "ssoToken": ssoToken,
            "req_method":"POST",
            "method":"getBannerList",
        }
        let url = 'http://localhost:3000/business/getBanners';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/business/getBanners';
        }
        axios.post(url, bannersData)
            .then(response => {
                dispatch(setBanners(response.data))
            })
            .catch(error => {
                dispatch(getBalanceFailed());
            })
    }
}

// Recent Bookings

    // Flight

    export const setFlightRecentBooking = (flightRecentBookingData) => {
        return {
            type: actionTypes.SET_FLIGHT_RECENT_BOOKING,
            val: flightRecentBookingData
        }
    }
    
    export const getFlightRecentBookingFailed = () => {
        return {
            type: actionTypes.GET_FLIGHT_RECENT_BOOKING_FAILED
        }
    }
    
    export const getFlightRecentBooking = (ssoToken) => {
        return dispatch => {
            let url = 'http://localhost:3000/recentSearch/getB2BRecentFlightBooking';
            if(prod) {
                url = 'https://secure.yatra.com/quicksilvercontroller/recentSearch/getB2BRecentFlightBooking';
            }
            axios.get(url, { 'headers' : { 'ssoToken': ssoToken } })
                .then(response => {
                    dispatch(setFlightRecentBooking(response.data));
                })
                .catch(error => {
                    dispatch(getFlightRecentBookingFailed())
                })
        }
    }

    // Hotel

    export const setHotelRecentBooking = (hotelRecentBookingData) => {
        return {
            type: actionTypes.SET_HOTEL_RECENT_BOOKING,
            val: hotelRecentBookingData
        }
    }
    
    export const getHotelRecentBookingFailed = () => {
        return {
            type: actionTypes.GET_HOTEL_RECENT_BOOKING_FAILED
        }
    }
    
    export const getHotelRecentBooking = (ssoToken) => {
        return dispatch => {
            let url = 'http://localhost:3000/recentSearch/getB2BRecentHotelBooking';
            if(prod) {
                url = 'https://secure.yatra.com/quicksilvercontroller/recentSearch/getB2BRecentHotelBooking';
            }
            axios.get(url, { 'headers' : { 'ssoToken': ssoToken } })
                .then(response => {
                    dispatch(setHotelRecentBooking(response.data));
                })
                .catch(error => {
                    dispatch(getHotelRecentBookingFailed())
                })
        }
    }

export const getAgentHeader = (ssoToken) => {
    return dispatch => {
        let url = 'http://localhost:3000/fresco/getAgentHeader';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/fresco/getAgentHeader';
        }
        axios.get(url, { 'headers' : { 'ssoToken': ssoToken } })
            .then(response => {
                console.log(response.data);
                dispatch(setAgentHeader(response.data));
            })
            .catch(error => {
                dispatch(setAgentHeaderFailed())
            })
    }
}

export const getAgentFooter = (ssoToken) => {
    return dispatch => {
        let url = 'http://localhost:3000/fresco/getAgentFooter';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/fresco/getAgentFooter';
        }
        axios.get(url, { 'headers' : { 'ssoToken': ssoToken } })
            .then(response => {
                console.log(response.data);
                dispatch(setAgentFooter(response.data));
            })
            .catch(error => {
                dispatch(setAgentFooterFailed())
            })
    }
}

export const setAgentHeader = (agentHeaderData) => {
    return {
        type: actionTypes.SET_AGENT_HEADER,
        val: agentHeaderData
    }
}

export const setAgentFooter = (agentFooterData) => {
    return {
        type: actionTypes.SET_AGENT_FOOTER,
        val: agentFooterData
    }
}

export const setAgentHeaderFailed = () => {
    return {
        type: actionTypes.SET_AGENT_HEADER_FAILED
    }
}

export const setAgentFooterFailed = () => {
    return {
        type: actionTypes.SET_AGENT_FOOTER_FAILED
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/auth.js